import { inject, Injectable } from '@angular/core';

import { LanguageService } from '@volo/ngx-lepton-x.core';
import { combineAndFilterByChildren, ISettingsService, Setting } from '@volosoft/ngx-lepton-x/layouts';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';

import { SapptpClockToggleComponent } from '../components/sapptp-settings/sapptp-clock-toggle.component';

// LeptonX supports a `component` property on Setting items at runtime for custom renderers,
// but it isn't reflected in the public Setting interface — cast through Partial to avoid unknown.
type ClockToggleSetting = Partial<Setting> & { component: unknown };
const clockToggleItem = { component: SapptpClockToggleComponent } as ClockToggleSetting as Setting;

@Injectable()
export class SapptpSidebarSettingsService implements ISettingsService {
  public settings$!: Observable<Setting[]>;
  public selectedSettings$!: Observable<Setting[]>;

  private languageService = inject(LanguageService);

  constructor() {
    this.selectedSettings$ = combineLatest([
      this.languageService.selectedLanguage$.pipe(
        map((lang) => ({ shortText: lang?.cultureName?.toLocaleUpperCase() } as Setting)),
      ),
    ]);

    this.settings$ = this.languageService.languagesAsSettingsGroup$.pipe(
      switchMap((languages) => {
        const hasMultipleLanguages = languages?.children?.length > 1;
        if (hasMultipleLanguages) {
          return combineAndFilterByChildren([of(languages)]).pipe(
            map((items) => [...items, clockToggleItem]),
          );
        }

        return of([clockToggleItem]);
      }),
    );
  }
}
